import statusModel from '../Models/StatusModel';

const STATUS_KEYS = {
  Incomplete: 'common.incomplete',
  Confirmed: 'orders.confirmed',
  'In progress': 'orders.in_progress',
  Shipped: 'common.shipped',
  'Customer unreachable': 'orders.customer_unreachable',
  'Out for delivery': 'orders.out_for_delivery',
  'Undelivered - Returned': 'orders.undelivered_returned',
  'Undelivered - Return confirmed': 'orders.undelivered_return_confirmed',
  Delivered: 'common.delivered',
  'Delivery confirmed': 'orders.delivery_confirmed',
  'Return initiated': 'orders.return_initiated',
  'Return picked': 'orders.return_picked',
  'Return confirmed': 'orders.return_confirmed',
  Disputed: 'orders.disputed',
  'Cancelled by seller': 'orders.canceled_by_seller',
  'Cancelled by customer': 'orders.canceled_by_customer',
  'Ready for pickup': 'orders.ready_for_pickup',
  Completed: 'orders.completed',
  'Order Confirmed': 'orders.confirmed',
  'Arrived at customer location': 'orders.arrived_at_customer_location',
  'Canceled By Admin': 'common.cancelled_by_admin',
};

export const translateOrderStatus = (code, translate) => {
  const label = statusModel.statusHandle(code);
  const key = STATUS_KEYS[label];
  return key ? translate(key, label) : label;
};
